import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
//import { Event } from '../core/models/event';
import { Router } from '@angular/router';
import { IconComponent } from '../widgets/icon/icon.component';
import { Event } from '@core/models/event';

@Component({
    selector: 'app-event-card',
    imports: [IconComponent],
    templateUrl: './event-card.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './event-card.component.scss'
})
export class EventCardComponent {

  constructor(
    private router: Router
  ) {}

  event!: Event;
  isDeletable: boolean = true;
  isClickable: boolean = true;
  isEventPlaceDisplayed : boolean = false;

  @Input() set eventObj(_eventObj: Event) {
    if (_eventObj) {
      this.event = _eventObj;
    }
  };

  @Input() set deletableEvent(_isDeletable: boolean) {
    this.isDeletable = _isDeletable;
  };

  @Input() set clickableEvent(_isClickable: boolean) {
    this.isClickable = _isClickable;
  };

  @Input() set displayEventPlace(_isDisplayed: boolean) {
    this.isEventPlaceDisplayed = _isDisplayed;
  };

  @Output() deleteEvent: EventEmitter<Event> = new EventEmitter();

  clickOnEvent(_event: Event) {
    //If the event isn't deletable is special case that mean he isn't clickable
    if (_event.EventId > 0 && this.isClickable) {
      this.router.navigate(['event/', _event.EventId], {
        state: { _event }
      });
    }
  }

  clickDeleteEvent() {
    this.deleteEvent.emit(this.event);
  }
}
